import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useFetch(url, deps = [], enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reload = useCallback(() => {
    if (!enabled || !url) { setLoading(false); return; }
    setLoading(true);
    api.get(url).then((r) => { setData(r.data); setError(null); }).catch((e) => setError(e)).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, enabled, ...deps]);
  useEffect(() => { reload(); }, [reload]);
  return { data, loading, error, reload, setData };
}

// Skala sumbu Y rapat: min−5 … max+5 (kelipatan 5, dijepit 0–100) agar naik/turun terlihat jelas
export const tightDomain = (rows, keys) => {
  const vals = (rows || []).flatMap((r) => keys.map((k) => r?.[k])).filter((v) => typeof v === "number" && !Number.isNaN(v));
  if (!vals.length) return [0, 100];
  const lo = Math.max(0, Math.floor((Math.min(...vals) - 5) / 5) * 5), hi = Math.min(100, Math.ceil((Math.max(...vals) + 5) / 5) * 5);
  return hi - lo < 10 ? [Math.max(0, lo - 5), Math.min(100, hi + 5)] : [lo, hi];
};
export const selectCls = "h-9 w-full rounded-md border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[color:var(--brand-blue)]";
